import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import MinSecInput from "@/components/app/MinSecInput";
import UnitInput from "@/components/app/UnitInput";
import { INTERVAL_GOALS } from "@/lib/intervals";

const GOAL_KEY_TESTID = (k) => `interval-goal-${k.replace(/_/g, "-")}`;

export default function IntervalsConfig({ b, update }) {
  const goal = INTERVAL_GOALS[b.interval_goal] || INTERVAL_GOALS.time_for_distance;
  return (
    <div className="space-y-4" data-testid="intervals-config">
      <div>
        <Label className="hs-label">Goal</Label>
        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid="interval-goal-options">
          {Object.entries(INTERVAL_GOALS).map(([k, g]) => {
            const active = b.interval_goal === k;
            return (
              <button key={k} type="button" onClick={() => update("interval_goal", k)}
                className={`text-left px-3 py-2 rounded-xl border transition-colors ${
                  active ? "bg-moss text-white border-moss" : "bg-muted2 text-ink border-line hover:bg-line"}`}
                data-testid={GOAL_KEY_TESTID(k)}>
                <div className="text-sm font-semibold">{g.label}</div>
                <div className={`text-[11px] ${active ? "text-white/80" : "text-ink-3"}`}>{g.hint}</div>
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <Label className="hs-label">Number of intervals</Label>
        <Input type="number" min="1" value={b.rounds ?? ""} onChange={(e) => update("rounds", e.target.value)}
               className="mt-2 h-11 rounded-xl font-data" data-testid="block-rounds" />
      </div>

      {goal.target === "distance" && (
        <UnitInput kind="distance" label="Target distance per interval" value={b.target_distance ?? ""}
          unit={b.target_distance_unit || "m"} testId="interval-target-distance"
          onChange={(v, u) => { update("target_distance", v ?? ""); update("target_distance_unit", u); }} />
      )}
      {goal.target === "calories" && (
        <div>
          <Label className="hs-label">Target calories per interval</Label>
          <Input type="number" min="0" value={b.target_calories ?? ""} onChange={(e) => update("target_calories", e.target.value)}
                 className="mt-2 h-11 rounded-xl font-data" placeholder="e.g., 20" data-testid="interval-target-calories" />
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="interval-work-rest">
        <MinSecInput label={goal.target === "time" ? "Work time per interval" : "Work time per interval (optional)"}
          min={b.target_time_min} sec={b.target_time_sec}
          onChange={(m, s) => { update("target_time_min", m); update("target_time_sec", s); }}
          testId="interval-target-time" hint={goal.target === "time" ? null : "time cap per effort"} />
        <MinSecInput label="Rest time between intervals" min={b.rest_min} sec={b.rest_sec}
          onChange={(m, s) => { update("rest_min", m); update("rest_sec", s); }}
          testId="interval-rest" hint="0 = no rest" />
      </div>
    </div>
  );
}
